import classNames from 'classnames';
import { formatMoney, formatNumber } from '@lib/utils';
import { useListingContext } from '../../context';

import {
  property_header_wrapper,
  property_header,
  address_wrapper,
  address_container,
  stat_container,
  stat_container_mobile,
  stat,
  stat_wrapper,
  price_container,
  is_mobile,
  is_desktop
} from './styles.module.scss';

const PropertyHeader = () => {
  const {
    address,
    city,
    state,
    zip,
    bedroomCount,
    bathroomCount,
    fullBathroomCount,
    partBathroomCount,
    squareFootage,
    acres,
    price,
    mlsNumber
  } = useListingContext();
  return (
    <div className={property_header_wrapper}>
      <div className={property_header}>
        <div className={address_wrapper}>
          <div className={address_container}>
            <h1>
              {address}{' '}
              <span>
                {city}, {state} {zip}
              </span>
            </h1>
          </div>
        </div>
        <div className={stat_container}>
          {!!bedroomCount && (
            <>
              <div className={stat_wrapper}>
                <div className={stat}>
                  <div>{bedroomCount}</div>
                  <div>Bed</div>
                </div>
              </div>
            </>
          )}
          {!!bathroomCount && (
            <>
              <div className={stat_wrapper}>
                <div className={stat}>
                  <div>
                    {partBathroomCount
                      ? `${fullBathroomCount}/${partBathroomCount}`
                      : fullBathroomCount}
                  </div>
                  <div>Bath</div>
                </div>
              </div>
            </>
          )}
          {!!squareFootage && !!squareFootage !== '0' && (
            <div className={classNames(stat_wrapper, is_desktop)}>
              <div className={stat}>
                <div>{formatNumber(squareFootage)}</div>
                <div>Sq. Ft</div>
              </div>
            </div>
          )}
          {!!acres && !!acres !== '0' && (
            <>
              <div className={stat_wrapper}>
                <div className={stat}>
                  <div>{acres}</div>
                  <div>Acres</div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={price_container}>
          <div>{formatMoney(price)}</div>
          <div>MLS# {mlsNumber}</div>
        </div>
      </div>

      <div className={classNames(is_mobile, stat_container_mobile)}>
        <div className={stat}>{bedroomCount && <div>{bedroomCount} BR</div>}</div>
        <div className={stat}>
          {!!fullBathroomCount && !!partBathroomCount ? (
            <div>
              {fullBathroomCount}/{partBathroomCount} BA
            </div>
          ) : bathroomCount ? (
            <div>{bathroomCount} BA</div>
          ) : (
            ''
          )}
        </div>
        {!!squareFootage && !!squareFootage !== '0' && (
          <div className={stat}>
            <div>{formatNumber(squareFootage)} Sq. Ft</div>
          </div>
        )}
        <div className={stat}>{!!acres && <div>{acres} AC</div>}</div>
      </div>
    </div>
  );
};

export default PropertyHeader;
